<div class="edit-profile-dialog-content no-close-btn-header d-flex flex-row"
  [ngClass]="{'edit-resume-popup': ctrl === 'PROFILE_ADD_EXP'}">
  <div class="popup-column-group profile-photo-video-column">
    <div class="column-title">Experience</div>
    <div class="photo-video-ui">
      <div class="photo-video-container">
        <div class="profile-video-ui-wrapper" [ngClass]="{'has-video': videoSelected}">
          <video (loadeddata)="positionVideo()" id="vidPreview" [hidden]="!videoSelected"
          [src]="selectedVideoUrl" autoplay loop muted playsinline></video>
        </div>
        <img id="imgPreview" [hidden]="videoSelected" class="imgPreview" height="100%" src="{{selectedPhoto}}">
        <img [hidden]="photoSelected || videoSelected" class="noProfilePhoto_img" width="100%" height="100%"
          src="../../../../assets/images/default-profile-picture-new.svg">
          <div class="ui-popover openToggler">
            <button id="muteBtn" [hidden]="!videoSelected" (click)="muted(!muteClassAdd)"
              class="item-video-sound-control" [ngClass]="{'mute' : muteClassAdd}">
            <img class="audio-control-icon-img mute-icon"
              src="../../../../assets/images/sound-muted-icon.png"
              srcset="../../../../assets/images/sound-muted-icon@2x.png 2x, ../../../../assets/images/sound-muted-icon@3x.png 3x">
              <img class="audio-control-icon-img sound-icon"
                src="../../../../assets/images/sound-unmuted-icon.png"
                srcset="../../../../assets/images/sound-unmuted-icon@2x.png 2x, ../../../../assets/images/sound-unmuted-icon@3x.png 3x">
              </button>
            </div>
          </div>
          <div ngbDropdown class="camera-menu dropdown">
            <button ngbDropdownToggle class="btn dropdown-toggle" type="button" id="cameraMenuDropdown">
              <img src="../../../../assets/images/profile-camera-icon.png"
                srcset="../../../../assets/images/profile-camera-icon@2x.png 2x, ../../../../assets/images/profile-camera-icon@3x.png 3x"
                class="profile-camera-icon">
            </button>
            <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right" aria-labelledby="cameraMenuDropdown">
              <a ngbDropdownItem (click)="recordVideo()" (keydown.enter)="recordVideo()" class="dropdown-item">Take a Video</a>
			  <a ngbDropdownItem (click)="removeVideo()" (keydown.enter)="removeVideo()" class="dropdown-item">Delete Video</a>
            </div>
          </div>
        </div>
        <div class="photo-video-hint">
          Record a short video describing your role, responsibilities, key achievements, and notable contributions during your time at this company.
        </div>
      </div>
      <div class="popup-column-group form-container-column edit-profile-content">
        <div class="modal-header">
          <h4 class="modal-title" id="modal-title">Work Experience</h4>
        </div>
        <div class="modal-body">
          <div class="required-legend"><span class="requiredAsterix">*</span> Required Information</div>
          <input type="hidden" [(ngModel)]="pageStatus" value="{{pageStatus}}" />
          <div class="unnanu-form-group-style-1 has-sussgestions-dropdown">
            <label class="unnanu-input-label-style-1">Company<span class="requiredAsterix">*</span></label>
            <input inputRestriction="allChars" [ngClass]="{'error': showCompanyError}" (blur)="hideCompanySuggestions()"
              maxlength="100" [(ngModel)]="company" type="" name="company"
              class="form-control unnanu-text-input-style-1" id="" value=""
              placeholder="Search or add company" [ngbTypeahead]="searchCompany"
              (selectItem)="companySelectedFn($event)" [resultTemplate]="rt" required (ngModelChange)="onChange($event)">
            <ng-template #rt let-r="result" let-t="term">
              <img [src]="(r.LogoUrl | logoUrl) || '../../../../assets/images/education-default.jpg'"
                (error)="$any($event.target).src='../../../../assets/images/education-default.jpg'"
                class="me-2" style="width:16px;height:16px;object-fit:contain;vertical-align:middle;">
              <ngb-highlight [result]="r.Name" [term]="t"></ngb-highlight>
            </ng-template>
            <label class="error" [hidden]="!showCompanyError">Enter a company name.</label>
          </div>
          <div class="unnanu-form-group-style-2 has-sussgestions-dropdown">
            <label class="unnanu-input-label-style-1">Title<span class="requiredAsterix">*</span></label>
            <input [ngClass]="{'error': showPositionError}" maxlength="100" [(ngModel)]="position"
              type="" name="" class="form-control unnanu-text-input-style-1" id="" value=""
              placeholder="Search or add title" (blur)="hidePositionSuggestions()"
              [ngbTypeahead]="searchPosition" (selectItem)="positionSelected($event)" [resultTemplate]="rtPos"
              [resultFormatter]="positionFormatter" (ngModelChange)="validatePosition(); onChange($event)">
            <ng-template #rtPos let-r="result" let-t="term">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#8a8a8a" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" class="me-2" style="vertical-align:middle;flex:0 0 auto;"><rect width="20" height="14" x="2" y="7" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>
              <ngb-highlight [result]="r.Name" [term]="t"></ngb-highlight>
            </ng-template>
            <label [hidden]="!showPositionError" class="error">Enter title</label>
          </div>
          <div class="unnanu-form-group-style-1 has-sussgestions-dropdown">
            <label class="unnanu-input-label-style-1">Location<span class="requiredAsterix">*</span></label>
            <city-suggestion inputRestriction="noSpecialChars" [data]="data" [parentobj]="parentobj" [showCityError]="showCityError" (cityUpdated)="onChange($event)">
            </city-suggestion>
            <label [hidden]="!parentobj.showCityError" class="error">Enter a location.</label>
          </div>
          <div class="unnanu-form-group-style-1">
            <label class="unnanu-input-label-style-1">Description</label>
            <textarea [(ngModel)]="description" rows="1" class="form-control unnanu-text-input-style-1"
            [ngClass]="{error: remaining() < 0}" maxlength="{{ maxLength }}" (ngModelChange)="onChange($event)"></textarea>
            @if (remaining() < 0) {
              <span>{{ remaining() }}</span>
            }
          </div>
          <div class="unnanu-form-group-style-1">
            <label class="unnanu-input-label-style-1">Time Period<span class="requiredAsterix">*</span></label>
            <div class="has-no-end-time">
              <span class="unnanu-check-box-style-1">
                <input inputRestriction="allChars" id="ItemDoesNotExpire" [(ngModel)]="isCurrentlyWorking" type="checkbox"
                  name="" class="form-check" (click)="currentlyWorking()" (ngModelChange)="onChange($event)"/>
                <label for="ItemDoesNotExpire"></label>
              </span>
              <label class="has-no-end-time-label" for="ItemDoesNotExpire">Currently Work Here</label>
            </div>
            <div class="time-duration-wrapper d-flex">
              <div class="duration-time has-month">
                <div class="month-year-group d-flex justify-content-between">
                  <div class="year">
                    <scroll-select class="periodMenu yearMenu" placeholder="Year" ariaLabel="Start year"
                      [options]="yearOptions" [value]="startYear"
                      (valueChange)="startYear = $event; onChange($event); validateTimePeriod()"></scroll-select>
                  </div>
                  <div class="month">
                    <scroll-select class="periodMenu yearMenu" placeholder="Month" ariaLabel="Start month"
                      [options]="startMonthOptions" [value]="startMonth.id"
                      (valueChange)="startMonth.id = $event; onChange($event); validateTimePeriod()"></scroll-select>
                  </div>
                </div>
                <div class="date-error-slot">
                  @if (startDateError) {
                    <label class="error">{{startDateErrorMessage}}</label>
                  }
                  @if (timePeriodError) {
                    <label class="error">{{timePeriodErrorMessage}}</label>
                  }
                </div>
              </div>
              <div class="duration-to-label">-</div>
              <div class="duration-time duration-end-time has-month" [hidden]="isCurrentlyWorking">
                <div class="month-year-group d-flex justify-content-between">
                  <div class="year">
                    <scroll-select class="periodMenu yearMenu" placeholder="Year" ariaLabel="End year"
                      [options]="endYearOptions" [value]="endYear"
                      (valueChange)="endYear = $event; onChange($event); validateTimePeriod()"></scroll-select>
                  </div>
                  <div class="month">
                    <scroll-select class="periodMenu yearMenu" placeholder="Month" ariaLabel="End month"
                      [options]="endMonthOptions" [value]="endMonth.id"
                      (valueChange)="endMonth.id = $event; onChange($event); validateTimePeriod()"></scroll-select>
                  </div>
                </div>
                <div class="date-error-slot">
                  @if (endDateError) {
                    <label class="error">{{endDateErrorMessage}}</label>
                  }
                </div>
              </div>
              <!-- End of the to time select dropdown -->
              <div [hidden]="!isCurrentlyWorking" class="duration-time duration-end-time">
                <div class="no-end-date-label">Present</div>
              </div>
            </div>
            <br>
            </div>
          </div>
          <div class="modal-footer text-right">
            <div class="footer-buttons-row d-flex justify-content-between align-items-center">
              @if (data.COGUID) {
                <button type="button" class="delete-card-button large float-left" (click)="deleteData()"
                  >
                  Delete
                </button>
              }
			  @else {
				<button type="button" class="delete-card-button large float-left"
                  >

                </button>
			  }
			  <div>
              <button type="button" class="cancel-changes-button large" (click)="close()">
                Cancel
              </button>
				<button type="button" class="save-changes-button large" [disabled]="!valueUpdated || !company.trim() || !position.trim()
                    || !parentobj.city || !startYear || startYear === 'Year:' || startMonth.id === '0'
                    || (!isCurrentlyWorking && (endYear === 'Year:' || endMonth.id === '0'))
                    || hasToShowCompanySuggestions || hasToShowPositionSuggestions || parentobj.showCityError
                    || startDateError || endDateError || timePeriodError"
                (click)="saveData()">
                Save Changes
              </button>
			</div>
            </div>
          </div>
        </div>
      </div>
